export const FEMALE = "female";
export const MALE = "male";
export const ANY = "any";

export const ADULT = "adult";
export const CHILD = "child";
export const YOUTH = "youth";
export const SENIOR = "senior";

export const PASSENGER_TYPES = [ADULT, CHILD, SENIOR] as const;
export type PassengerType = (typeof PASSENGER_TYPES)[number];

// We don't use the one from integration-packages
// because it's not tree shakable
enum Gender {
  Female = "female",
  Male = "male"
}

export const UDMGender = {
  Male: Gender.Male,
  Female: Gender.Female
} as const;

export type PassengerGender = "male" | "female" | "other";

export const MAX_PASSENGERS_NUMBER = 5;
